try {
// Copy buttons (data-copy). The show/hide toggles (data-copy-toggle) are handled by lys-v4-panel-toggle.js since 2026-10-27.
(function(){
  document.querySelectorAll('[data-copy]').forEach(function(b){
    b.addEventListener('click', function(){
      var el = document.getElementById(b.getAttribute('data-copy'));
      var txt = el.innerText, label = b.textContent;
      function done(){ b.textContent = 'Copied ✓'; setTimeout(function(){ b.textContent = label; }, 1600); }
      function fallback(){ var r = document.createRange(); r.selectNodeContents(el); var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); try { document.execCommand('copy'); done(); } catch(e){ b.textContent = 'Press ⌘/Ctrl+C'; } }
      try { navigator.clipboard.writeText(txt).then(done, fallback); } catch(e){ fallback(); }
    });
  });
})();
} catch (e) { console.error("lys-v4 copy-toggle", e); }
